import { JourneyRoute, LoaderFunctionArgsWithContext } from '@cash-web/shared-journey-util-main'

const navigateToP2P = async ({ context }: LoaderFunctionArgsWithContext) => {
  context?.browserNavigate('/account/pay-and-request')
}

export const p2pClientRoutes = [
  {
    id: 'view-payment-pad',
    trackingName: 'View Payment Pad',
    path: 'dl/view/payment-pad',
    loader: navigateToP2P,
  },
  {
    id: 'view-pay-cashtag-amount',
    trackingName: 'View Pay Cashtag Amount',
    path: 'dl/view/pay/:cashtag/:amount',
    loader: navigateToP2P,
  },
  {
    id: 'view-pay-cashtag-amount-note',
    trackingName: 'View Pay Cashtag Amount Note',
    path: 'dl/view/pay/:cashtag/:amount/note/:base64Note',
    loader: navigateToP2P,
  },
  {
    id: 'view-pay-sms',
    trackingName: 'View Pay SMS',
    path: 'dl/view/pay-sms-v2/:base64Phone',
    loader: navigateToP2P,
  },
  {
    id: 'view-pay-email',
    trackingName: 'View Pay Email',
    path: 'dl/view/pay-email-v2/:base64Email',
    loader: navigateToP2P,
  },
  {
    id: 'view-request-cashtag-amount',
    trackingName: 'View Request Cashtag Amount',
    path: 'dl/view/request/:cashtag/:amount',
    loader: navigateToP2P,
  },
  {
    id: 'view-request-cashtag-amount-note',
    trackingName: 'View Request Cashtag Amount Note',
    path: 'dl/view/request/:cashtag/:amount/note/:base64Note',
    loader: navigateToP2P,
  },
  {
    id: 'view-request-sms',
    trackingName: 'ViewRequest SMS',
    path: 'dl/view/request-sms/:base64Phone',
    loader: navigateToP2P,
  },
  {
    id: 'view-request-email',
    trackingName: 'View Request Email',
    path: 'dl/view/request-email/:base64Email',
    loader: navigateToP2P,
  },
  {
    id: 'view-pay-and-request',
    trackingName: 'View Pay and Request',
    path: 'web/view/pay-and-request',
    lazy: async () => ({
      Component: (await import('@cash-web/account-feature-p2p')).JourneyPayAndRequest,
    }),
  },
] as const satisfies JourneyRoute[]
